import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditStockModuleContext from 'contexts/EditStockModuleContext';
import { StockReception } from 'types/models/StockReceipt';
import { getStockReception } from 'services/stockReceptionServices';
import StockReceptionForm from 'forms/StockReceptionForm';

export default (): JSX.Element => {
  const { t } = useTranslation();
  const history = useHistory();
  const { receptionId } = useParams<{ receptionId: string }>();
  const { selectedReception } = React.useContext(EditStockModuleContext);
  const [completeStockReception, setCompleteStockReception] = React.useState<StockReception | null>(null);

  React.useEffect(() => {
    const id = selectedReception?.id ?? receptionId;

    if (!id) {
      history.replace('/private/stock/receptions');
      return;
    }

    let mounted = true;

    (async () => {
      const reception = await getStockReception(id);

      if (!mounted) return;

      if (!reception) {
        history.replace('/private/stock/receptions');
        return;
      }

      setCompleteStockReception(reception);
    })();

    return () => {
      mounted = false;
    };
  }, [selectedReception, receptionId, history]);

  if (!selectedReception && !receptionId) return <></>;
  if (!completeStockReception) return <div>{t('loading')}</div>;

  return <StockReceptionForm reception={completeStockReception} isReadOnly />;
};
